import { select, takeEvery } from 'redux-saga/effects';
import { AdminOrganizationsApi } from 'api';
import { sagasHandlersFactory } from 'store/entities/utils';
import { AdminEventsSelectors } from 'store/selectors';
import * as actions from './actions';

export const handleGetAdminEventStatistics = sagasHandlersFactory.createGetOneRequestHandler({
  actions: actions.getAdminEventStatistics,
  request: AdminOrganizationsApi.getAdminEventStatistics,
  requestArgsBuilder: (action) => {
    const { organizationId } = action.payload.params;
    return [organizationId, action.payload.id];
  },
  transformResponse: function* transformResponse(response, action) {
    yield select(AdminEventsSelectors.adminEventStateById, Number(action.payload.id));
    return {
      id: action.payload.id,
      ...response,
      tickets_ordered: response.tickets_statistics ?? [],
    };
  },
});

export default function* adminEventStatistics() {
  yield takeEvery(actions.getAdminEventStatistics.request.type, handleGetAdminEventStatistics);
}
